/*
 * popup Actions
 *
 * @version 1.0.0
 * @author Pietro Bertuccelli
 * @since 04-Sep-2024
 */

import { createAction } from './index'

export const actionTypes = {
  DO_SHOW_POPUP: '@@popup/show_popup',
  DO_HIDE_POPUP: '@@popup/hide_popup'
  // @generator action:type
  // @generator action:type:request
}

// ------------------------------------
// Actions
// ------------------------------------
// @generator action:request
// @generator action
/** @action
* * Insert a description
* @name HidePopup
* @return {object} - The payload object
*/
export const doHidePopup = payload => createAction(actionTypes.DO_HIDE_POPUP, { payload })
/** @action
* * Insert a description
* @name ShowPopup
* @return {object} - The payload object
*/
export const doShowPopup = (key, moreInfo, id) => createAction(actionTypes.DO_SHOW_POPUP, { key, moreInfo, id })
